























































































































































import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import api from '@/api';
import config from '$config';
import common from '@/common';
const imageValidator = /(png|jpg|jpeg|gif)$/;
import { createApiRequest } from '@/api/request'
import util from '@/util'
import { convertPdfToImage } from '@/libs/pdfjs'

@Component({
    name: 'UploadImgAndFile'
})
export default class UploadImgAndFile extends Vue {
    $message: any;
    $refs: any
    config: any = config;
    dialogVisible: boolean = false;
    dialogImageUrl: string = '';

    @PropSync('fileList', { default: () => []})
    showFileList!: any[];

    @Prop({
        type: Boolean,
        default: () => {
            return false;
        }
    })
    edit!: boolean;

    @Prop({
        default: 'url'
    })
    urlKey!: string;

    @Prop({
        default: true
    })
    needShow!: boolean; // 是否需要展示列表

    @Prop({
        default: ''
    })
    showPosition!: boolean; // 展示列表在什么位置

    @Prop({
        default: false
    }) helperFormStyle!: boolean

    imageList: any = []

    imageIndex: any = 0

    isImage(url: string) {
        if (url) {
            return imageValidator.test(url.toLowerCase());
        } else {
            return false;
        }
    }

    deletePicture(index) {
        this.showFileList.splice(index, 1);
        this.$emit('deletePic', this.showFileList[index]);
    }

    previewPicture(index) {
        if (this.helperFormStyle) {
            this.imageIndex = index
            this.imageList = util.cloneDeep(this.showFileList);
            this.imageList = this.imageList.map(item => config.ossPrefix + item.url);
            this.$nextTick(() => {
                (this.$refs as any).elImageRef.clickHandler();
            })
        } else {
            this.dialogImageUrl = this.urlKey ? this.showFileList[index][this.urlKey] : this.showFileList[index];
            console.log(this.dialogImageUrl)
            if (this.isImage(this.dialogImageUrl)) {
                this.dialogVisible = true;
            } else {
                common.openOssUrl(this.dialogImageUrl)
            }
        }
    }

    downloadPicture(item) {
        const filePath = this.urlKey ? item[this.urlKey] : item;
        const fileName = this.urlKey ? item.name : item;
        common.downloadOssFile(common.getRelativeUrl(filePath), fileName);
    }

    previewPdf(url: string) {
        window.open(url, '_blank');
    }

    // 上传
    selectFileList: any = [];
    dragging: boolean = false;
    draggingHelper: boolean = false

    @Prop({
        type: Boolean,
        default: false
    })
    disabled!: boolean

    @Prop({
        type: Boolean,
        default: () => {
            return false;
        }
    })
    drag!: boolean; // 是否支持拖拽上传

    @Prop({
        type: Boolean,
        default: () => {
            return false;
        }
    })
    clickIcon!: boolean; // 是否是点击上传

    @Prop({
        type: String,
        default: () => {
            return '180px';
        }
    })
    dragHeight!: boolean; // 拖拽框的高度

    @Prop({
        type: Number,
        default: () => {
            return 1000;
        }
    })
    maxUploadNumber!: number; // 文件数量上限

    @Prop({
        type: Number,
        default: () => {
            return 1024 * 1024 * 100;
        }
    })
    maxFileSize!: number; // 文件上传的最大值（字节）

    isLoading: boolean = false

    /**
     * 文件类型
     * xls：application/vnd.ms-excel
     * xlsx: application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
     * jpg: image/jpeg
     * svg: image/svg+xml
     * zip: application/zip
     * pdf: application/pdf
     */
    @Prop({
        type: String,
        default: () => {
            return '';
        }
    })
    accept!: string; // 可接受文件类型

    @Prop({
        type: String,
        default: function() {
            return 'File upload failed!';
        }
    })
    errorAcceptMsg!: string;

    @Prop({
        type: Boolean,
        default: () => {
            return false;
        }
    })
    multiple!: boolean; // 是否支持多文件上传

    @Prop({
        type: Boolean,
        default: () => {
            return true;
        }
    })
    autoUpload!: boolean; // 自动上传

    @Prop({default: ''})
    actionUrl!: any;

    @PropSync('uploadLoading', {default: false}) buttonLoading!: boolean


    onDragenter(e) {
        this.dragging = true;
        e.stopPropagation();
        e.preventDefault();
    }

    onDragleave(e) {
        this.dragging = false;
        e.stopPropagation();
        e.preventDefault();
    }

    onDragover(e) {
        this.dragging = true;
        e.preventDefault();
    }

    onDrop(e) {
        this.dragging = false;
        e.stopPropagation();
        e.preventDefault();
        const files = e.dataTransfer.files;
        this.dragFileToServer(files);
    }

    dragFileToServer(files) {
        if (Array.from(files).length === 0) {
            return;
        }
        const acceptTypeList = this.accept.split(',').map(val => new RegExp(val));
        const fileTypeList = Array.from(files).map((file: any) => file.type);
        const fileTypeStatus = fileTypeList.every(type => acceptTypeList.some(reg => reg.test(type)));
        if (!fileTypeStatus) {
            this.$message.error(this.errorAcceptMsg);
            return;
        } else {
            this.uploadFile(Array.from(files));
        }
    }

    async uploadFile(files) {
        if (this.disabled) {
            const errorMsg: string = 'You can upload at most ' + this.maxUploadNumber + ' file(s!)';
            this.$message.error(errorMsg);
            return;
        }
        const maxUploadFileStatus = files.length > (this.maxUploadNumber - this.showFileList.length);
        const fileSizeStatus = files.some(file => file.size > this.maxFileSize);
        if (maxUploadFileStatus) {
            const errorMsg: string = 'You can upload at most ' + this.maxUploadNumber + ' file(s!)';
            this.$message.error(errorMsg);
            return;
        }

        if (fileSizeStatus) {
            const errorMsg: string = 'File size should not be over ' + Math.floor(this.maxFileSize / 1024 / 1024) + ' MB.';
            this.$message.error(errorMsg);
            return;
        }

        this.buttonLoading = true

        const promiseFileList: any = [];
        this.isLoading = true
        for (let i = 0; i < files.length; i++) {
            const formData: FormData = new FormData();
            const file = files[i];
            let Fn: Function = api.upload_file;
            if (this.actionUrl) {
                Fn = createApiRequest({
                    method: 'POST',
                    url: this.actionUrl
                } as any);
                formData.append('file', file);
            } else {
                if ((/^image\/+/).test(file.type) || file.type === 'application/pdf') {
                    Fn = api.upload_file;
                    formData.append('file', file);
                } else if ((/^video\/+/).test(file.type)) {
                    Fn = api.upload_file;
                    formData.append('file', file);
                } else {
                    Fn = api.upload_file;
                    formData.append('file', file);
                }
            }
            promiseFileList[i] = Fn(formData);
        }

        promiseFileList.map(p => p.catch(e => e));
        Promise.all(promiseFileList).then(result => {
            result.forEach((res: any, key: number) => {
                const data: any = res.data || '';
                let obj: any = {
                    name: files[key].name
                };
                this.urlKey ? obj[this.urlKey] = data : (obj = data);
                this.showFileList.push(obj);
            });
            if (this.helperFormStyle) {
                (this.$refs.dropdownRef as any).handleClick();
            }
            this.$emit('handleSuccess');
        }).finally(() => {
            this.clearFile();
            this.buttonLoading = false
            this.isLoading = false
        });
    }

    selectFile() {
        if (this.disabled) {
            return
        }
        this.clearFile();
        (this.$refs.uploadInput as any).click();
    }

    // 捕获input的change事件，获取上传到浏览器的文件
    inputFileChange() {
        const fileComponent = (this.$refs.uploadInput as HTMLInputElement);
        const file: FileList | null = fileComponent.files;
        if (file) {
            this.formatUploadFileParams(Array.from(file));
        } else {
            return;
        }
    }

    // 格式化文件参数
    formatUploadFileParams(file) {
        if (Array.isArray(file)) {
            const maxUploadFileStatus = file.length > (this.maxUploadNumber - this.showFileList.length);
            if (maxUploadFileStatus) {
                const errorMsg: string = 'You can upload at most ' + this.maxUploadNumber + ' file(s!)';
                this.$message.error(errorMsg);
                return;
            }
            this.selectFileList = file;
            this.readyUpload();
        } else {
            return;
        }
    }

    // 上传前准备
    readyUpload() {
        // 判断是否自动上传
        if (this.autoUpload) {
            this.uploadFile(this.selectFileList);
        } else {
            return;
        }
    }

    dataURLtoBlob(dataUrl: any, fileName: string) {
        const arr = dataUrl.split(','); const mime = arr[0].match(/:(.*?);/)[1];
        const bStr = atob(arr[1]); let n = bStr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bStr.charCodeAt(n);
        }
        return new File([u8arr], fileName, { type: mime });
    }

    compressImg(file, size) {
        return new Promise(resolve => {
            const reader = new FileReader();
            const image: any = new Image();
            const fileName = file.name;
            image.onload = () => {
                const canvas = document.createElement('canvas');
                const context: any = canvas.getContext('2d');
                const width = image.width * size;
                const height = image.height * size;
                canvas.width = width;
                canvas.height = height;
                context.clearRect(0, 0, width, height);
                context.drawImage(image, 0, 0, width, height);
                const newURL = canvas.toDataURL();
                const binaryData = this.dataURLtoBlob(newURL, `${fileName}`);
                resolve(binaryData);
            };
            reader.onload = ((e: any) => { image.src = e.target.result; });
            reader.readAsDataURL(file);
        });
    }

    clearFile() {
        const fileComponent = (this.$refs.uploadInput as HTMLInputElement);
        if (fileComponent) fileComponent.value = '';
        this.selectFileList = [];
    }
}
